---
title: "Installing the Mobile App"
category: "Mobile"
order: 1
description: "How to add Hourglass to your phone's home screen"
---

> **Note:** Mobile access may not be available for all firms. Some firms require a VPN connection, and others may not have mobile access enabled. If you're unsure, check with your firm's admin.

Hourglass works as a mobile app that you install directly from your browser — no app store needed. Once installed, it opens in its own window with no address bar, just like a native app.

Your Hourglass URL is: <HostnameDisplay />

## <IconHeading icon="Apple">iPhone / iPad (Safari only)</IconHeading>

You **must** use Safari — this will not work in Chrome, Firefox, or any other browser on iOS.

1. Open **Safari** and go to <HostnameDisplay />
2. Sign in if you haven't already
3. Tap the **Share** button (the square with an arrow pointing up, in the bottom toolbar)
4. Scroll down and tap **Add to Home Screen**
5. Tap **Add** in the top-right corner

Hourglass will appear on your home screen as an app icon. Tap it to open — it runs fullscreen, just like a native app.

<div className="flex justify-center my-4">
<video src="/videos/mobile-app-ios-install.mp4" controls playsInline muted className="rounded-lg border w-full max-w-[200px]" />
</div>


## <IconHeading icon="Smartphone">Android (Chrome)</IconHeading>

1. Open **Chrome** and go to <HostnameDisplay />
2. Sign in if you haven't already
3. Tap the **three-dot menu** in the top-right corner
4. Tap **Add to Home Screen** or **Install app**
5. Tap **Install** or **Add**

On some Android devices you may see a banner at the bottom of the screen prompting you to install — tap that instead.

## <IconHeading icon="LifeBuoy">Need Help?</IconHeading>

If you're having trouble installing or the app isn't working as expected, visit [Support](/support) to schedule a meeting.
